// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"221":"755e872c","234":"433e938f","510":"9ad5e02f","548":"4c9b0add","633":"da3701b0","794":"61738cca","849":"c365b0bd"}[chunkId] + ".chunk.css";
};